<template>
  <div
    class="group relative bg-white dark:bg-dark-surface rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-800 hover:border-accent/20 dark:hover:border-accent/30 will-change-transform"
  >
    <!-- Step Number Badge -->
    <div class="flex items-start space-x-6 mb-6">
      <div
        class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-accent to-accent-600 dark:from-accent-400 dark:to-accent-600 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300"
      >
        <span class="text-2xl font-display font-bold text-white">
          {{ number }}
        </span>
      </div>

      <!-- Icon -->
      <div
        v-if="icon"
        class="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-primary/10 to-primary/5 dark:from-primary/20 dark:to-primary/10 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
      >
        <component
          :is="icon"
          :size="28"
          class="text-primary dark:text-primary-300"
        />
      </div>
    </div>

    <!-- Content -->
    <div class="relative z-10">
      <h3 class="text-2xl font-display font-bold text-gray-900 dark:text-white mb-3">
        {{ title }}
      </h3>

      <p class="text-gray-600 dark:text-gray-400 leading-relaxed mb-6">
        {{ description }}
      </p>

      <!-- Activities List -->
      <ul v-if="activities && activities.length" class="space-y-2">
        <li
          v-for="(activity, index) in activities"
          :key="index"
          class="flex items-start space-x-3 text-sm text-gray-600 dark:text-gray-400"
        >
          <div
            class="flex-shrink-0 w-1.5 h-1.5 rounded-full bg-accent dark:bg-accent-300 mt-2"
          ></div>
          <span>{{ activity }}</span>
        </li>
      </ul>
    </div>

    <!-- Decorative Elements -->
    <div
      class="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-accent/5 to-transparent dark:from-accent/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"
    ></div>

    <!-- Connection Line (for showing flow between steps) -->
    <div
      v-if="showConnector"
      class="absolute -bottom-8 left-8 w-0.5 h-8 bg-gradient-to-b from-accent/30 to-transparent dark:from-accent/50"
    ></div>
  </div>
</template>

<script setup>
defineProps({
  number: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  activities: {
    type: Array,
    default: () => []
  },
  icon: {
    type: Object,
    default: null
  },
  showConnector: {
    type: Boolean,
    default: false
  }
});
</script>
